// Cart drawer: reveal quantity stepper on demand (only one open at a time)
//
// Expects markup:
// - toggle button:   data-qty-toggle, aria-controls="PanelId", aria-expanded="false"
// - panel container: data-qty-panel, id="PanelId", hidden
//
// Safe with cart drawer re-renders because it uses event delegation.

(function initCartDrawerQtyReveal() {
  function closePanel(panel) {
    if (!panel) return;
    panel.hidden = true;

    const id = panel.id;
    if (!id) return;

    // Find the toggle that controls this panel and update aria-expanded.
    const toggle = document.querySelector(`[data-qty-toggle][aria-controls="${CSS.escape(id)}"]`);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function openPanel(panel, toggle) {
    console.log('Open panel: ', panel);
    if (!panel) return;
    panel.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (toggle) toggle.setAttribute('hidden', 'true');

    // Optional: focus the input so the user can immediately change qty.
    const input = panel.querySelector('input.quantity__input');
    if (input) input.focus({ preventScroll: true });
  }

  function closeAllPanels(exceptPanel = null) {
    document.querySelectorAll('[data-qty-panel]').forEach((panel) => {
      if (exceptPanel && panel === exceptPanel) return;
      if (!panel.hidden) closePanel(panel);
    });
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-qty-toggle]');
    if (!toggle) return;

    // Only handle toggles inside the cart drawer (prevents accidental matches elsewhere).
    const drawer = toggle.closest('cart-drawer');
    if (!drawer) return;

    const panelId = toggle.getAttribute('aria-controls');
    if (!panelId) return;

    const panel = drawer.querySelector(`#${CSS.escape(panelId)}`);
    if (!panel) return;

    // If this panel is already open, do nothing (you said no need to close it).
    if (!panel.hidden) return;

    // Close any other open panel, then open this one.
    closeAllPanels(panel);
    openPanel(panel, toggle);
  });
})();
